/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { headerBreak } from '@/components/content/Header/styles/break';
import { SxProps, Theme } from '@mui/material';

export const headerContainerSX = (theme: Theme) => ({
	width: '100vw',
	backgroundColor: 'background.paper',
	boxShadow: 'none',
	borderRadius: 0,
	top: 0,
	position: headerBreak({ mobile: 'sticky', desktop: 'relative' }),
	// lower zIndex because store locator autocomplete zIndex is 1000
	zIndex: headerBreak({ mobile: `${theme.zIndex.mobileStepper}`, desktop: 'unset' }),
	overflow: 'unset',
	borderBottom: `1px solid ${theme.palette.grey[50]}`,
});

export const headerStoreSectionContainerSX: SxProps = {
	borderRadius: '0',
	paddingLeft: '13px',
};

export const headerStoreSectionStackContainerSX: SxProps = {
	'@media (min-width: 1920px)': {
		maxWidth: '1920px',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
};

export const headerSectionButtonContainerSX = (isStoreLocator: boolean): SxProps => ({
	flex: isStoreLocator ? headerBreak({ mobile: '2', desktop: '1' }) : 1,
	display: 'flex',
	justifyContent: 'center',
});

export const headerStoreSectionStackCDividerSX: SxProps = {
	alignSelf: 'center',
	mr: 0.5,
	height: headerBreak({ mobile: '32px', desktop: '18px' }),
};

export const headerContainerComponentSX: SxProps = {
	padding: '10px',
	'@media (min-width: 1920px)': {
		maxWidth: '1920px',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
};

export const headerStoreSectionNoGrowContainer: SxProps = {
	flex: '0 0 auto',
};

export const headerStoreSectionGrowContainer: SxProps = {
	flex: '1 1 auto',
};
